import './backdrop.css';
export default {
  "backdrop": "pf-v6-c-backdrop",
  "backdropOpen": "pf-v6-c-backdrop__open"
};